<template>
  <!-- 新增企业 -->
  <div class="addresident">
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      title="基本信息"
      :visible.sync="this.vis"
      width="1170px"
      :before-close="handleClose"
    >
      <div class="bodymsg">
        企业基本信息
      </div>
      <el-form :inline="true" :rules="rules" :model="enterpriseform"  label-width="170px" class="demo-form-inline">
        <el-form-item label="单位名称">
          <el-input  v-model="enterpriseform.name" placeholder="单位名称"></el-input>
        </el-form-item>
        <el-form-item label="单位类型">
           <el-select v-model="userform.partyType" placeholder="请选择单位类型">
            <el-option label="有限责任公司" value="0"></el-option>
            <el-option label="股份有限公司" value="1"></el-option>
            <el-option label="个体" value="2"></el-option>
            <el-option label="机关事业" value="3"></el-option>
            <el-option label="其他" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="userform.idCode" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="userform.personName" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="法定代表人">
          <el-input v-model="userform.idCode" placeholder="法定代表人"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号">
          <el-input v-model="userform.idCode" placeholder="法人身份证号"></el-input>
        </el-form-item>
        <el-form-item label="从业人员数量">
          <el-input v-model="userform.idCode" placeholder="从业人员数量"></el-input>
        </el-form-item>
        <el-form-item label="经营面积">
          <el-input v-model="userform.idCode" placeholder="经营面积"></el-input>
        </el-form-item>
        <el-form-item label="经营范围">
          <el-input v-model="userform.idCode" placeholder="经营面积"></el-input>
        </el-form-item>
        <el-form-item label="健康证">
          <el-select v-model="userform.partyType" placeholder="请选择">
            <el-option label="无" value="0"></el-option>
            <el-option label="有" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="健康证人数">
         <el-input v-model="userform.idCode" placeholder="健康证人数"></el-input>
        </el-form-item>
        <el-form-item label="未持证人数">
          <el-input v-model="userform.birthDay"  placeholder="未持证人数"></el-input>
        </el-form-item>
        <el-form-item label="营业执照">
          <el-select v-model="userform.partyType" placeholder="请选择">
            <el-option label="无" value="0"></el-option>
            <el-option label="有" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册号">
          <el-input  v-model="userform.originPlace"  placeholder="注册号"></el-input>
        </el-form-item>
        <el-form-item label="食品经营许可证">
         <el-select v-model="userform.partyType" placeholder="请选择">
            <el-option label="无" value="0"></el-option>
            <el-option label="有" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号">
          <el-input v-model="userform.personAge" placeholder="证件号"></el-input>
        </el-form-item>
        <el-form-item label="食品经营许可证核发日期">
          <el-date-picker v-model="userform.birthDay" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker v-model="userform.birthDay" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="注册地址">
           <el-input v-model="userform.personAge" placeholder="注册地址"></el-input>
        </el-form-item>
        <el-form-item label="经营品种">
          <el-input v-model="userform.personAge" placeholder="经营品种"></el-input>
        </el-form-item>
        <el-form-item label="办公地点">
           <el-input v-model="userform.personAge" placeholder="办公地点"></el-input>
        </el-form-item>
        <el-form-item label="成立时间">
          <el-date-picker v-model="userform.birthDay" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="注册资金">
           <el-input v-model="userform.personAge" placeholder="注册资金"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="userform.commissary" placeholder="请选择">
            <el-option label="餐饮" value="0"></el-option>
            <el-option label="经营" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btnform" style="width:100%" label="">
          <el-button
            v-show="arorreset == 'add'"
            type="primary"
            @click="onSubmit1"
            >新增</el-button
          >
          <el-button
            v-show="arorreset == 'reset'"
            type="primary"
            @click="onSubmit1"
            >修改</el-button
          >
          <el-button type="primary" @click="handleClose">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["vis"],
  data() {
    return {
      // ? door upload photo and file
      girduploadfilephoto:
        "https://i.postimg.cc/6pLMHDKx/71577176366-pic-hd.png",
      girduploadfile: "", // ? door's  e.target.files[0]
      formSwitch: 2,
      familyform: {},
      userform: {},
      enterpriseform:{
        name:'',
      },
       rules: {
          name: [
            { required: true, message: '请输入单位名称', trigger: 'blur' },
          ],
          region: [
            { required: true, message: '请选择活动区域', trigger: 'change' }
          ]
        },
      loading: false,
      olddoorCode: "",
      // 判断用户点击的事修改还是新增
      arorreset: ""
    };
  },
  // created() {
  //   // console.log(this.$attrs);
  // },
  mounted() {
    // 监听添加,修改人员的点击事件
    this.$Bus.$on("addenterprise", (userform, familyform, ar) => {
      this.getdata(userform, familyform, ar);
    });
  },
  beforeDestroy() {
    // 页面销毁前 取消所有事件总线的监听
    this.$Bus.$off();
  },
  computed: {
    channel() {
      return this.familyform.doorCode;
    }
    // channel2() {
    //   return this.familyform.doorCodeHide;
    // }
  },
  watch: {
    channel(newValue, oldValue) {
      // this.oldmenpai = oldValue;
      // 　　　　console.log('new: %s, old: %s', newval, oldVal)
      this.familyform.familyCode =
        this.familyform.sectionMapId +
        "part_" +
        this.familyform.cellNum +
        "_" +
        newValue; //这里面可以执行一旦监听的值发生变化你想做的操作
      this.familyform.doorCodeHide =
        "part_" + this.familyform.cellNum + "_" + newValue;
    }
  },
  methods: {
    // ? upload door photo
    uploadConfiggrid(e) {
      console.log(e.target.files);
      let _this = this;
      let files = e.target.files[0];
      this.girduploadfile = files;
      if (!e || !window.FileReader) return; // 看支持不支持FileReader
      let reader = new FileReader();
      reader.readAsDataURL(files); // 这里是最关键的一步，转换就在这里
      reader.onloadend = function() {
        _this.girduploadfilephoto = this.result;
      };
    },
    // box点击时,触发input的点击事件
    up_click_girdhead() {
      this.$refs["gird_up"].click();
    },
    getdata(userform, familyform, ar) {
      this.familyform = JSON.parse(JSON.stringify(familyform));
      this.userform = JSON.parse(JSON.stringify(userform));
      this.userform.familyCode = this.familyform.familyCode;
      this.olddoorCode = this.familyform.doorCode;
      console.log(ar);
      this.arorreset = ar;
    },
    // 关闭弹出框
    handleClose() {
      this.$emit("close");
      this.familyform = {};
      this.userform = {};
      this.girduploadfilephoto = "";
      this.girduploadfile = "";
    },
    // 表单2-新增逐户基本信息-提交,修改
    async onSubmit1() {
      this.loading = true;
      
      let formData = new FormData();
      // formData.append("familyCode", this.familyform.familyCode);

      formData.append("personVo", JSON.stringify(this.userform));
      formData.append("personFile", this.girduploadfile);
      let result = await this.$http.post("/admin/person/info/insertPerson", formData);
      // console.log(result);
      this.loading = false;
      this.$message(result.message);
      this.$emit("reset");
      this.handleClose();
    },
    // 表单1-家庭基本信息-修改
    //  门牌号验证
    async searchis() {
      // this.loading = true;
      // 户号书去焦点时触发事件 查询户号是否重复
      if (this.olddoorCode == this.familyform.doorCode) {
        return;
      }
      let formData = new FormData();
      formData.append("familyCode", this.familyform.familyCode);
      let result = await this.$http.post(
        "/admin/family/info/findFamilyByCode",
        formData
      );
      if (result.message == "该门牌号已存在") {
        this.$alert("该门牌号已使用", "标题名称", {
          confirmButtonText: "确定",
          callback: action => {
            this.familyform.doorCode = this.olddoorCode;
            this.$forceUpdate();
          }
        });
      }
      // this.loading = false;
      this.$message(result.message);
    },
    async resetSubmit1() {
      this.loading = true;

      let formData = new FormData();
      // formData.append("familyCode", this.familyform.familyCode);

      formData.append("familyVo", JSON.stringify(this.familyform));
      let result = await this.$http.post("/admin/family/info/updateFamily", formData);
      console.log(result);
      this.$message(result.message);
      this.loading = false;

      this.$emit("resetrenyuan");
    },
    // ?  control  second and last form switch
    chickpage(e) {
      this.formSwitch = e;
    }
  }
};
</script>

<style lang="less" scoped>
.addresident {
  .el-dialog {
    overflow: hidden;
  }
  .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    height: 637px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
  }
  .bodymsg {
    width: 140px;
    height: 40px;
    background-color: #ffb404;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 2px;
    margin-top: 20px;
    cursor: pointer;
  }
  .switchpage {
    display: inline-block;
    margin-bottom: 10px;
  }
  .activesiwtch {
    background-color: #d6d7d8;
  }
  .el-form-item {
    text-align: right;
    margin-bottom: 11px;
    .el-input {
      width: 290px;
      border-radius: 5px;
    }
  }
  // 按钮的el-form-item 单独写样式
  .btnform {
    text-align: center;
  }
  .el-form-item:nth-child(2n) {
    width: 46%;
  }
  .el-form-item:nth-child(2n + 1) {
    width: 40%;
  }
}
#file2 {
  display: none;
}
.doorphoto {
  display: inline-block;
  height: 95px;
  width: 95px;
  border: 1px dashed rgb(170, 170, 170);
  position: relative;
  border-radius: 5px;
  margin-right: 200px;
  .dooricon {
    color: #333;
    position: absolute;
    font-size:42px;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }
}
.imgbox {
  width: 70px !important;
  height: 95px !important;
  margin: 0 auto;
  background-color: #fff;
  img {
    background-color: #fff;
    width: 70px;
    height: 95px;
    // background-image: url("https://i.postimg.cc/6pLMHDKx/71577176366-pic-hd.png");
  }
}
</style>